import type { CompareLeft, CompareRight } from '../../data-contract/position-alignment';

export const positionAlignmentKeys = {
    alignment: (alignmentId: string) => [...positionAlignmentKeys.alignments(), alignmentId] as const,
    alignments: () => [...positionAlignmentKeys.all, 'alignment'] as const,
    all: ['position-alignment'] as const,
    automations: (alignmentId: string) => [...positionAlignmentKeys.alignment(alignmentId), 'automations'] as const,
    compare: (alignmentId: string, left: CompareLeft, right: CompareRight) =>
        [...positionAlignmentKeys.compares(alignmentId), left, right] as const,
    compares: (alignmentId: string) => [...positionAlignmentKeys.alignment(alignmentId), 'compare'] as const,
    task: (alignmentId: string, taskId: string) => [...positionAlignmentKeys.tasks(alignmentId), taskId] as const,
    taskAutomationRecommendation: (alignmentId: string, taskId: string) =>
        [...positionAlignmentKeys.task(alignmentId, taskId), 'automation-recommendation'] as const,
    tasks: (alignmentId: string) => [...positionAlignmentKeys.alignment(alignmentId), 'task'] as const,
    position: (alignmentId: string) => [...positionAlignmentKeys.alignment(alignmentId), 'position'] as const,
    me: () => [...positionAlignmentKeys.all, 'me'] as const,
    team: () => [...positionAlignmentKeys.all, 'team'] as const,
    threads: (alignmentId: string) => [...positionAlignmentKeys.alignment(alignmentId), 'threads'] as const,
} as const;
